var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('GrindingOrderIndex',{attrs:{"schedule_id":_vm.id}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }